import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import BulkPOServices from '@Services/purchase/purchaseOrders/bulkPOServices';
import BulkPOActions, { bulkPOActionTypes } from '@Actions/purchase/purchaseOrders/bulkPOActions';

/**
 * @param action
 */
function* _getBulkPO(action) {
  try {
    yield put(BulkPOActions.getBulkPOLoading(true));
    const {
      orgId, bulkPOType, status, page, limit, searchKeyword,
    } = action;
    const bulkPOs = yield BulkPOServices.getBulkPO(orgId, bulkPOType, status, page, limit, searchKeyword);
    yield put(BulkPOActions.getBulkPOSuccess(bulkPOs));
    if (action.callback) {
      action.callback(bulkPOs);
    }
    yield put(BulkPOActions.getBulkPOLoading(false));
  } catch (error) {
    yield put(BulkPOActions.getBulkPOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bulkPOActionTypes.GET_BULK_PO.ERROR, error));
  }
}

/**
 *
 */
function* getBulkPO() {
  yield takeLatest(bulkPOActionTypes.GET_BULK_PO.REQUEST, _getBulkPO);
}
/**
 * @param action
 */
function* _createBulkPO(action) {
  try {
    yield put(BulkPOActions.createBulkPOLoading(true));
    const bulkPO = yield BulkPOServices.createBulkPO(action.payload);
    if (bulkPO.success) {
      yield put(TrackerActions.trackAction(bulkPOActionTypes.CREATE_BULK_PO.SUCCESS, bulkPO.data));
      notification.open({
        type: 'success',
        message: 'Purchase order successfully created',
        duration: 4,
        placement: 'top',
      });
      yield put(BulkPOActions.createBulkPOLoading(false));
      if (action.callback) {
        action.callback(bulkPO);
      }
    } else {
      notification.open({
        type: 'error',
        message: bulkPO?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(BulkPOActions.createBulkPOLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bulkPOActionTypes.CREATE_BULK_PO.ERROR, error));
    yield put(BulkPOActions.createBulkPOLoading(false));
  }
}

/**
 *
 */
function* createBulkPO() {
  yield takeLatest(bulkPOActionTypes.CREATE_BULK_PO.REQUEST, _createBulkPO);
}

/**
 *
 * @param {*} action
 */
function* _updateBulkPO(action) {
  try {
    yield put(BulkPOActions.updateBulkPOLoading(true));
    const bulkPO = yield BulkPOServices.updateBulkPO(action.payload);
    if (bulkPO.success) {
      yield put(TrackerActions.trackAction(bulkPOActionTypes.UPDATE_BULK_PO.SUCCESS, bulkPO.data));
      notification.open({
        type: 'success',
        message: 'Purchase order updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(BulkPOActions.updateBulkPOLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: bulkPO?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(BulkPOActions.updateBulkPOLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bulkPOActionTypes.UPDATE_BULK_PO.ERROR, error));
    yield put(BulkPOActions.updateBulkPOLoading(false));
  }
}

/**
 *
 */
function* updateBulkPO() {
  yield takeLatest(bulkPOActionTypes.UPDATE_BULK_PO.REQUEST, _updateBulkPO);
}

/**
 * @param action
 */
function* _updateBulkPOStatus(action) {
  try {
    yield put(BulkPOActions.updateBulkPOStatusLoading(true));
    const bulkPOStatusUpdate = yield BulkPOServices.updateBulkPOStatus(action.payload);
    if (bulkPOStatusUpdate.success) {
      notification.open({
        type: 'success',
        message: 'Planned purchase order status updated successfully.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: bulkPOStatusUpdate?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) {
      action.callback();
    }
    yield put(BulkPOActions.updateBulkPOStatusLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bulkPOActionTypes.UPDATE_PO_STATUS.ERROR, error));
    yield put(BulkPOActions.updateBulkPOStatusLoading(false));
  }
}

/**
 *
 * @return {Generator<*, void, *>}
 */
function* updateBulkPOStatus() {
  yield takeLatest(bulkPOActionTypes.UPDATE_BULK_PO_STATUS.REQUEST, _updateBulkPOStatus);
}

/**
 * @param action
 */
function* _getBulkPOById(action) {
  try {
    yield put(BulkPOActions.getBulkPOByIdLoading(true));
    const {
      orgId, bulkPOType, bulkPOId, callback,
    } = action;
    const selectedBulkPO = yield BulkPOServices.getBulkPOById(orgId, bulkPOType, bulkPOId);
    yield put(BulkPOActions.getBulkPOByIdSuccess(selectedBulkPO?.data?.blanket_pos?.[0]));
    if (callback) {
      action.callback(selectedBulkPO?.purchase_order?.[0]?.seller_info?.seller_id);
    }
    yield put(BulkPOActions.getBulkPOByIdLoading(false));
  } catch (error) {
    yield put(BulkPOActions.getBulkPOByIdLoading(false));
    yield put(TrackerActions.trackAction(bulkPOActionTypes.GET_BULK_PO_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getBulkPOById() {
  yield takeLatest(bulkPOActionTypes.GET_BULK_PO_BY_ID.REQUEST, _getBulkPOById);
}

/**
 * @param action
 */
function* _deleteBulkPO(action) {
  try {
    yield put(BulkPOActions.deleteBulkPOLoading(true));
    const deletedPo = yield BulkPOServices.deleteBulkPO(action.payload);
    if (deletedPo.success) {
      notification.open({
        type: 'success',
        message: 'Purchase has been deleted.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: deletedPo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BulkPOActions.deleteBulkPOLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bulkPOActionTypes.DELETE_BULK_PO.ERROR, error));
    yield put(BulkPOActions.deleteBulkPOLoading(false));
  }
}

/**
 *
 */
function* deleteBulkPO() {
  yield takeLatest(bulkPOActionTypes.DELETE_BULK_PO.REQUEST, _deleteBulkPO);
}

/**
 *
 */
export default function* bulkPOSaga() {
  yield all([
    getBulkPO(), createBulkPO(), updateBulkPO(), getBulkPOById(), deleteBulkPO(), updateBulkPOStatus(),
  ]);
}
